import styled from "styled-components";
import { ServicesBg } from "../../../ui/AllImages";



export const ServiceWrapper = styled.section`
    background-image: url(${ServicesBg});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    .heading-text{
        width:80%;
    }
    .service-card{
        display:flex;
        padding: 25px 0 25px  15px;
        border-radius: 10px;
        background-color: var(--white);
       
        background-position: right top;
        background-repeat: no-repeat;
        flex-direction: column;
        gap: 10px;
        gap:12px;
        margin:15px 0;
        height:168px;
        width:100%;
        &>span{
            svg{
                height:54px;
            }
        }
        & p{
            font-size:14px;
        }
    }
`
export const AchivementWrapper = styled.section`

    background-color:var(--themeColor);
    border-radius: 16px;
    .item-container{
        background-image: url(${ServicesBg});
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        background-color: var(--themeColor);
        background-position: right bottom;
        background-repeat: no-repeat;
        flex-wrap: nowrap;
        border-radius: 10px;
        /* margin: 10px 0; */
        padding: 32px 32px 32px 32px;
        position: relative;
    }
    #features & .item-box{
        position:relative;
        color:var(--white);
        padding: 15px 25px 15px 16px;
        margin-bottom: 20px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 12px;
        font-family: var(--medium) !important;
        font-size: 16px;
        display: flex;
        align-items: center;
        gap: 8px;
        line-height: 1.3;
        cursor: pointer;
        /* &::after{
            content: '';
            width: 20px;
            height: 20px;
            position: absolute;
            right: 10px;
            top: 5px;
            
            background-size: 100%;

        } */
            
        
    }
    
    #features & .active-item-box{
        background-color: var(--white);
        font-family: var(--semiBold) !important;
        color: var(--themeColor);
        .navTabIcon{
            svg{
                [stroke] {
                    stroke: var(--themeColor);
                }
                [fill] {
                    fill: var(--themeColor);
                }
            }
           /* background-color: #E5C89B;
            border-radius: 8px;
            color: var(--themeColor); */
        }
    }
    
    .navTabIcon{
        display: flex;
        width: 24px;
        height: 24px;
        align-items: center;
        justify-content: center;
        /* font-family: var(--familyRbt) !important;
        font-weight: var(--regular);
        font-size: 16px;
        background-color: var(--text);
        border-radius: 8px;
        color: var(--text2); */
    }
    /* .service-content-number{
        display: flex;
        position: absolute;
        right: -80px;
        top: 40px;
        font-family: var(--familyRbt) !important;
        font-weight: var(--extraBold);
        font-size: 150px;
        color: rgba(255, 255, 255, 0.1);
        line-height: 1;
        z-index: -1;
    } */
    .item-container-left{
        min-width: 245px;
        max-width: 245px;
        
    }

    .serArrowList{
        display: flex;
        min-width: 20px;
        max-width: 20px;
        padding-top: 3px;
    }

    .service-solution-data-container{
        position: relative;
        padding: 0 0 0 15px;
        background-position: right bottom !important;
        background-repeat: no-repeat !important;
        z-index: 5;
        .service-list-container{
            
        }
        
    }
    .ssd-wrapper{
        width: calc(100% - 250px);
    }
    &.serviceArchiveSec{
        padding-top: 70px;
        padding-bottom: 0;
    }
    .service-solution-list{
        display: flex;
        gap: 15px;
        justify-content: space-between;

    }
    .service-img-container{
        width: 100%;
        img{
            width: 100%;
        }
    }
    body.rtl #features &{
        .item-box{
            font-family: var(--arRegular) !important;
            font-weight: var(--regular) !important;
            font-size: 18px;
            padding: 10px 16px 10px 25px;
        }
        .active-item-box{
            font-family: var(--arBold) !important;
            font-weight: var(--bold) !important;
            font-size: 18px;
        }
        .serArrowList{
            padding-top: 7px;
        }
        .item-container{
            padding: 32px 20px 32px 32px;
        }
        .service-content-number{
            right: auto;
            left: -80px;
        }
    }

    .mobile-view{
        display:none;
    }
    @media (max-width: 1299px) {
        .service-content-number{
            right: -30px;
        }
        body.rtl #features &{
         .service-content-number{
                right: auto;
                left: -30px;
            }   
        }
    }
    @media (max-width: 1199px) {
        .servicesDescRow {
            padding-left: 10px !important;
            padding-right: 10px !important;
        }
        
        .item-container{
            padding: 32px 10px 32px 10px;
        }
        .service-solution-data-container {
            padding: 0 0 0 0;
        }
        body.rtl #features &{
            .item-container{
                padding: 32px 10px 32px 10px;
            }
            .service-solution-data-container {
                padding: 0 0 0 0;
            }
        }
    }
    @media (max-width: 991px) {
        .item-container-left{
            min-width: 100%;
            max-width: 100%;
        }
        
        .main-heading-choose{
            font-size: 30px;
            margin-top: 20px;
        }
        .whyListTxt{
            font-size: 16px;
        }
        .servicesDescCol1{
            max-width: 100% !important;
            min-width: 100% !important;
        }
        .servicesDescCol2 {
            width: 100% !important;
        }
        
        .servicesDescRowInner{
            padding-bottom: 0px !important;
        }
        .item-container{
            padding: 10px 10px 32px 10px;
        }
        .desktop-view{
            display: none;
        }
        body.rtl #features &{
            .main-heading-choose{
                font-size: 30px;
                margin-top: 20px;
            }
            .item-container{
                padding: 10px 10px 32px 10px;
            }
            
        }

    }
    @media (max-width: 767px) {
        .servicesDescRow {
            padding-left: 5px !important;
            padding-right: 5px !important;
        }
        .item-container{
            padding: 10px 5px 32px 5px;
        }
        
        body.rtl #features &{
            .main-heading-choose{
                font-size: 28px;
            }
            
            
        }

    }


`